import { Municipality } from '@dofleini/location-ui';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const MunicipalitySelect = ({ onChange, province, ...props }) => {
  return (
    <Municipality
      {...props}
      provAcr={province}
      onChange={onChange}
      disabled={!province}
      canSearch
    />);
};

export default memo(MunicipalitySelect);

MunicipalitySelect.defaultProps = {
  province: '',
};

MunicipalitySelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  province: PropTypes.any,
};

export const renderMunicipalitySelect = ({ formItemProps, field, form }, parentProvince) => {
  
  return (
    <Form.Item {...formItemProps} initialValue={field?.initialValue} required={field?.required} rules={[{required: true}]}>
      <MunicipalitySelect {...field?.widgetProps} {...field} province={parentProvince} form={form}/>
    </Form.Item>
  );
};

renderMunicipalitySelect.propTypes = {
  formItemProps: PropTypes.object,
  field: PropTypes.object,
  form: PropTypes.object,
};
